import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import SectionHeader from '../../atoms/SectionHeader';
import StandardLayout from '../../templates/StandardLayout';

export const FarbRaume = ({ heading, description, images, handleShowRoom }) => (
  <StandardLayout>
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell xsmall-14 small-12 medium-10 xsmall-offset-1 small-offset-2 medium-offset-3">
          <SectionHeader>
            <Heading extraClass="section__title--banner" level={1}>
              {heading}
            </Heading>
          </SectionHeader>
        </div>
      </div>
    </div>

    <div className="grid-container">
      <div className="farbraum">
        <div className="grid-x">
          <div className="cell large-16 medium-16">
            <div className="farbraum__description">{description}</div>
          </div>
          <div className="cell large-16 medium-16">
            <div className="farbraum__images">
              {images &&
                images.map((image, index) => (
                  <div
                    role="presentation"
                    key={`farbraum${index}`}
                    onClick={() => handleShowRoom(index)}
                    className="farbraum__images image_wrapper"
                  >
                    <img src={image} alt="" />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);
FarbRaume.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.string,
  handleShowRoom: PropTypes.func,
};
